import React, {Component} from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import constants from "../../constants";
import axios from "axios";
import {toast} from "react-toastify";
import * as XLSX from "xlsx";
import Modal from "react-modal";
import "./index.css";


class MotoboysPayment extends Component
{
    baseUrl = '';
    isSuperUser = '';
    token = '';
    userId = '';

    dateInit = '';
    dateEnd = '';
    status = [];
    paymentMethod = [];
    formRegisterPix = {
        pix_type: '',
        pix_key: '',
        owner_name: '',
        owner_cpf: ''
    };
    priceTotalServices = 0;
    totalServices = 0;
    motoboySelected = {
        driver_id: null
    };

    queryReports = '';
    reloadReport = false;
constructor(props) {
        super(props);
        this.state = {
            reports: [],
            servicesList: [],
            reportViewModal: {
                driver: {
                    driverUser: {},
                    driverBank: {}
                },
                services: []
            },
            motoboySelected: {
                driverUser: {},
                driverBank: {},
            },
            drivers: [],
            reportsSelected: [],
            priceTotalServices: 0,
            totalServices: 0,
            transactionId: '',
            datePayment: '',
            loadingSearch: false,
            loadingExport: false,
            loadingGenerateSolicitation: false,
            loadingRegisterPix: false,
            modalGeneratePayments: false,
            modalServicesList: false,
            modalRegisterPIX: false,
            modalCancelTransaction: false,
            loadingCancelTransaction: false
        }

        this.baseUrl = constants().URL_API;

        this.changeDateInit = this.changeDateInit.bind(this);
        this.changeDateEnd = this.changeDateEnd.bind(this);
        this.changeStatus= this.changeStatus.bind(this);
        this.changePaymentMethod= this.changePaymentMethod.bind(this);
        this.changePixKey = this.changePixKey.bind(this);
        this.changePixType = this.changePixType.bind(this);
        this.changeOwnerName = this.changeOwnerName.bind(this);
        this.changeOwnerCPF = this.changeOwnerCPF.bind(this);
        this.searchReports = this.searchReports.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.exportToExcelPayments = this.exportToExcelPayments.bind(this);
        this.selectMotoboy = this.selectMotoboy.bind(this);
        this.getMotoboys = this.getMotoboys.bind(this);
        this.showReports = this.showReports.bind(this);
        this.cancelTransaction = this.cancelTransaction.bind(this);
        this.changeTransactionId = this.changeTransactionId.bind(this);
        this.changeDatePayment= this.changeDatePayment.bind(this);
        this.getStatusReport= this.getStatusReport.bind(this);



        this.verifyIsChecked= this.verifyIsChecked.bind(this);
        this.addOrRemoveServiceFromList = this.addOrRemoveServiceFromList.bind(this);
        this.calculateServicesSelect = this.calculateServicesSelect.bind(this);
        this.toggleModalGeneratePayments = this.toggleModalGeneratePayments.bind(this);
        this.toggleModalServicesList = this.toggleModalServicesList.bind(this);
        this.toggleModalRegisterPIX = this.toggleModalRegisterPIX.bind(this);
        this.toggleModalCancelTransaction = this.toggleModalCancelTransaction.bind(this);
        this.registerPix = this.registerPix.bind(this);
        this.generateSolicitationPixMotoboy = this.generateSolicitationPixMotoboy.bind(this);
        this.generateSolicitationPixAllMotoboy = this.generateSolicitationPixAllMotoboy.bind(this);
        this.changeSearchReport = this.changeSearchReport.bind(this);
        this.getTotalReportsWithServices = this.getTotalReportsWithServices.bind(this);
        this.selectAllServicesMotoboy = this.selectAllServicesMotoboy.bind(this);
        this.unselectAllServices = this.unselectAllServices.bind(this);

    }

    //FUNCTIONS FORMATE
    currencyFormat(num)
    {
        return 'R$ ' + num
    }

    formatDate(date)
    {
        const _date = new Date(date);
        return _date.toLocaleDateString() + ' ' + _date.toLocaleTimeString();
    }

    empty(val)
    {
        return val === '' || val == null || val === 0;
    }

    async changePixType(el)
    {
        this.formRegisterPix.pix_type = el.target.value;
    }

    async changePixKey(el)
    {
        this.formRegisterPix.pix_key = el.target.value;
    }

    async changeOwnerName(el)
    {
        this.formRegisterPix.owner_name = el.target.value;
    }

    async changeOwnerCPF(el)
    {
        this.formRegisterPix.owner_cpf = el.target.value;
    }

    async changeDateInit(el)
    {
        this.dateInit = el.target.value;
    }

    async changeDateEnd(el)
    {
        this.dateEnd = el.target.value;
    }

    async changeStatus(el)
    {
        if(el.target.checked)
        {
            this.status.push(el.target.value);
        }
        else
        {
            this.status = this.status.filter((v) => Number(v) !== Number(el.target.value));
        }
    }

    async changePaymentMethod(el)
    {
        if(el.target.checked)
        {
            this.paymentMethod.push(el.target.value);
        }
        else
        {
            this.paymentMethod = this.paymentMethod.filter((v) => Number(v) !== Number(el.target.value));
        }
    }

    orderByName(arr)
    {
        return arr.sort((a, b) => {
            if(arr.driver.driverUser.first_name != null)
            {
                return a.driver.driverUser.first_name.localeCompare(b.driver.driverUser.first_name);
            }
        });

    }

    orderReports(reports)
    {
        for(const report of reports)
        {
            if(report.services.length)
            {
                report.services = report.services.sort((c, d) => {
                    return d.price - c.price;
                })
            }
        }
        reports = reports.sort((a, b) => b.total - a.total)
        return reports;
    }

    async searchReports()
    {
        if(this.dateInit === '')
        {
            return;
        }
        if(this.dateEnd === '')
        {
            return;
        }
        if(this.status === '')
        {
            return;
        }
        if(this.paymentMethod === '')
        {
            return;
        }

        let params = {
            userId: this.userId,
            dateInit: this.dateInit,
            dateEnd: this.dateEnd,
            status: this.status,
            paymentMethod: this.paymentMethod
        };
        if(!this.empty(this.motoboySelected) && !this.empty(this.motoboySelected.driver_id))
        {
            params.driverId = this.motoboySelected.driver_id.toString();
        }

        this.setState({loadingSearch: true})
        axios.post(this.baseUrl+'/financial/reports/motoboy-services', params)
            .then(response => {
                const data = response.data
                this.setState({loadingSearch: false})
                if (data.code === 1)
                {
                    for(let report of data.details.reports)
                    {
                        report.show = 1;
                    }
                    this.setState({'reports': data.details.reports ? data.details.reports : []});
                }

                else
                {
                    this.setState({'reports': []})
                    this.servicesList = [];
                    toast.info(data.message);
                }
                this.calculateServicesSelect();


            }).catch((error) => {
                this.setState({loadingSearch: false})
                console.log(error.message);
        })
    }

    convertValue(_value)
    {
        let value = Number(_value).toFixed(2);
        return parseFloat(value);
    }

    convertDateTime(_value)
    {
        let valueSplit = _value.split(' ');
        let date = valueSplit[0];
        let hour = valueSplit[1];
        let hourSplit = hour.split('.')
        if(hourSplit.length > 1)
        {
            hour = hourSplit[0];
        }

        return date.split('-').reverse().join('/') + '-' + hour;
    }

    convertDateToExcel(_value)
    {
        let valueSplit = _value.split(' ');
        let date = valueSplit[0];

        return date.split('-').reverse().join('-');
    }

    async verifyIsChecked(id)
    {
        for(const report of this.state.reports)
        {
            for(const service of report.services)
            {
                if((Number(service.id) === Number(id)) && service.isSelected === 1)
                {
                    return true;
                }
            }
        }
        return false;
    }

    async _addOrRemoveServiceFromList(checked, id, index)
    {
        for(const report of this.state.reports)
        {
            for(const service of report.services)
            {
                if(Number(service.id) === Number(id))
                {
                    service.isSelected = checked ? 1 : 0;
                }
            }
        }
    }

    async addOrRemoveServiceFromList(checked, id, index)
    {
        this._addOrRemoveServiceFromList(checked, id, index).then(() => {
            this.calculateServicesSelect();
        })
    }

    async calculateServicesSelect()
    {
        let total = 0;
        let total_paid = 0;
        let total_services_paid = 0;
        let total_w_tax = 0;
        let quantity_services = 0
        let quantity_services_paid = 0
        let totalReports = 0;
        let totalWithTaxReports = 0;
        let quantityServicesReport = 0;
        let quantityServicesReportPaid = 0;

        if(this.state.reports.length)
        {
            //this.servicesList = [];
            let countReport = 0;
            for(const report of this.state.reports)
            {
                if(report.isSelected)
                {
                    total = 0;
                    total_paid = 0;
                    total_w_tax = 0;
                    quantity_services = 0;
                    quantity_services_paid = 0;
                    for(const service of report.services)
                    {
                        if(service.isSelected === 1)
                        {
                            service.price_w_tax = service.price - (service.price * service.administrative_tax);
                            if(service.is_motoboy_payment === 1)
                            {
                                total_paid += service.price_w_tax;
                                quantity_services_paid++;
                            }
                            else
                            {
                                quantity_services++;
                                total += Number(service.price);
                                console.log(typeof service.price)
                                total_w_tax+= service.price_w_tax;
                            }

                        }
                        service.reportIndex = countReport;
                    }
                    report.total = this.convertValue(total);
                    report.total_w_tax = this.convertValue(total_w_tax);
                    report.total_paid = this.convertValue(total_paid);
                    report.quantity_services = quantity_services;
                    report.quantity_services_paid = quantity_services_paid;
                    totalReports += total;
                    totalWithTaxReports += total_w_tax;
                    total_services_paid += total_paid;
                    quantityServicesReport += quantity_services;
                    quantityServicesReportPaid += quantity_services_paid;
                    countReport++;
                }
            }
        }

        const reorderReports = this.orderReports(this.state.reports);
        this.setState({reports: reorderReports});
        this.setState({totalServices: quantityServicesReport});
        this.setState({priceTotalWithTaxServices: this.convertValue(totalWithTaxReports)});
        this.setState({priceTotalServices: this.convertValue(totalReports)});
        this.setState({priceTotalPaid: this.convertValue(total_services_paid)});
    }

    getStatusService(val)
    {
        let status = '';
        switch (val)
        {
            case 1:
                status = 'Pendente';
                break;

            case 4:
                status = 'Finalizado';
                break;

            case 5:
                status = 'Cancelado';
                break;

            case 6:
                status = 'Recusado';
                break;
        }

        return status;
    }

    async exportToExcel()
    {
        this.setState({loadingExport: true})
        let data = [];
        let count = 1;
        let total = 0;
        let totalWithTax = 0;
        for(const service of this.servicesList)
        {
            if(service.isSelected === 1)
            {
                let dataToPush = {
                    '#': count,
                    'ID': service.id,
                    'ESTABELECIMENTO': service.establishment_name,
                    'ENDEREÇO DE ENTREGA': service.arrival_address,
                    'SERVIÇO': service.service_type,
                    'FORMA DE PAGAMENTO': service.payment_method,
                    'MOTOBOY' : service.driver_name,
                    'CÓDIGO ENTREGADOR': service.driver_id,
                    'VALOR BRUTO': this.convertValue(service.price),
                    'VALOR LIQUIDO': this.convertValue(service.price_w_tax),
                    'STATUS DE SERVIÇO': this.getStatusService(service.status),
                    'PAGAMENTO': this.empty(service.is_motoboy_payment) ? 'Pendente' : 'Pago',
                    'DATA DO SERVIÇO': this.convertDateTime(service.datetime)
                };
                data.push(dataToPush);
                total+= Number(service.price);
                totalWithTax+= Number(service.price_w_tax);
                count++;
            }
        }
        let dataToPush = {
            '#': '',
            'ID': '',
            'ESTABELECIMENTO': '',
            'ENDEREÇO DE ENTREGA': '',
            'SERVIÇO': '',
            'FORMA DE PAGAMENTO': '',
            'MOTOBOY' : '',
            'CÓDIGO ENTREGADOR': '',
            'VALOR BRUTO': this.convertValue(total),
            'VALOR LIQUIDO': this.convertValue(totalWithTax),
            'STATUS DE SERVIÇO': '',
            'PAGAMENTO': '',
            'DATA DO SERVIÇO': ''
        };
        data.push(dataToPush);
        const nameDates = this.convertDateToExcel(this.dateInit)+ ' a ' + this.convertDateToExcel(this.dateEnd);
        let workSheet = XLSX.utils.json_to_sheet(data);
        let workBook = XLSX.utils.book_new();
        let name = "Serviços Dos Motoboys " + nameDates;

        XLSX.utils.book_append_sheet(workBook, workSheet, nameDates);
        XLSX.writeFile(workBook, name+".xlsx", { compression: true })
        this.setState({loadingExport: false})
    }

    async exportToExcelPayments()
    {
        this.setState({loadingExport: true})
        let data = [];
        let count = 1;
        let total = 0;
        let total_w_tax = 0;
        let total_paid = 0;
        let quantity_services = 0;
        let quantity_services_paid = 0;
        let totalServices = 0;
        for(let report of this.state.reports)
        {
            for(let service of report.services)
            {
                if(service.is_motoboy_payment === 1)
                {
                    total_paid += service.price_w_tax;
                    quantity_services_paid++;
                }
                else
                {
                    quantity_services++;
                    total += service.price;
                    total_w_tax+= service.price_w_tax;
                }
            }

            totalServices += report.services.length;
            const splitId = report.driver.driverUser.last_name.split('-')
            const driverName = report.driver.driverUser.first_name + ' ' + splitId[0];
            let dataToPush = {
                '#': count,
                'MOTOBOY' : driverName,
                'CÓDIGO ENTREGADOR': splitId[1],
                'CHAVE PIX': report.driver.driverBank.pix_key,
                'TOTAL CORRIDAS': report.services.length,
                'TOTAL PAGO': report.total_paid,
                'TOTAL RECEBER': report.total_w_tax,
                'STATUS': this.getStatusReportText(report.services)
            };
            data.push(dataToPush);
            count++;

        }
        let dataToPush = {
            '#': '',
            'MOTOBOY' : '',
            'CÓDIGO ENTREGADOR': '',
            'CHAVE PIX': '',
            'TOTAL CORRIDAS': quantity_services,
            'TOTAL PAGO': this.convertValue(total_paid),
            'TOTAL RECEBER': total_w_tax,
            'STATUS': ''
        };
        data.push(dataToPush);
        const nameDates = this.convertDateToExcel(this.dateInit)+ ' a ' + this.convertDateToExcel(this.dateEnd);
        let workSheet = XLSX.utils.json_to_sheet(data);
        let workBook = XLSX.utils.book_new();
        let name = "Relatório de pagamentos de Entregadores " + nameDates;

        XLSX.utils.book_append_sheet(workBook, workSheet, nameDates);
        XLSX.writeFile(workBook, name+".xlsx", { compression: true })
        this.setState({loadingExport: false})
    }

    async toggleModalGeneratePayments()
    {
        if(this.state.modalGeneratePayments)
        {
            const reportTemp = this.state.reports;
            for(const report of reportTemp)
            {
                for(const service of report.services)
                {
                    for(const serviceList of this.servicesList)
                    {
                        if(Number(service.id) === Number(serviceList.id))
                        {
                            service.isSelected = serviceList.isSelected;
                            break;
                        }
                    }
                }
            }
            this.setState({reports: reportTemp})

            this.calculateServicesSelect().then(() => {
                this.setState({ modalGeneratePayments: !this.state.modalGeneratePayments })
            })

        }
        else
        {
            this.setState({ modalGeneratePayments: !this.state.modalGeneratePayments })
        }

    }

    async toggleModalServicesList(report = null)
    {
        if(this.state.modalServicesList)
        {
            //CLOSE MODAL
            this.setState({
                reportViewModal: {
                    driver: {
                        driverUser: {},
                        driverBank: {}
                    },
                    services: []
                }
            })
        }
        else
        {
            //OPEN MODAL
            this.setState({reportViewModal: report})
        }

        this.setState({ modalServicesList: !this.state.modalServicesList })
    }

    async toggleModalRegisterPIX(motoboy)
    {
        if(this.state.modalRegisterPIX)
        {
            this.setState({motoboySelected: {
                    driverUser: {},
                    driverBank: {},
                }});
        }
        else
        {
            this.setState({motoboySelected: motoboy});
            if(
                motoboy.driverBank.owner_name != null ||
                motoboy.driverBank.owner_name !== ''
            )
            {
                this.formRegisterPix.owner_name = motoboy.driverBank.owner_name;
            }
            if(
                motoboy.driverBank.owner_cpf != null ||
                motoboy.driverBank.owner_cpf !== ''
            )
            {
                this.formRegisterPix.owner_cpf = motoboy.driverBank.owner_cpf;
            }
            if(
                motoboy.driverBank.pix_type != null ||
                motoboy.driverBank.pix_type !== ''
            )
            {
                this.formRegisterPix.pix_type = motoboy.driverBank.pix_type;
            }
            if(
                motoboy.driverBank.pix_key != null ||
                motoboy.driverBank.pix_key !== ''
            )
            {
                this.formRegisterPix.pix_key = motoboy.driverBank.pix_key;
            }

        }
        this.setState({ modalRegisterPIX: !this.state.modalRegisterPIX })
    }

    async registerPix()
    {
        if(
            this.formRegisterPix.pix_type === '' ||
            this.formRegisterPix.pix_key === '' ||
            this.formRegisterPix.owner_cpf === '' ||
            this.formRegisterPix.owner_name === ''
        )
        {
            toast.info("Preencha todos os campos");
            return;
        }

        this.formRegisterPix.id = this.state.motoboySelected.driverBank.id ? this.state.motoboySelected.driverBank.id : 0;

        this.setState({loadingRegisterPix: true})
        axios.post(this.baseUrl+'/motoboys/update-pix-info', this.formRegisterPix)
        .then(response => {
            const data = response.data;
            this.setState({loadingRegisterPix: false})
            if(data.code === 1)
            {
                for(const report of this.state.reports)
                {
                    if(report.driver.driverUser.id === this.state.motoboySelected.driverUser.id)
                    {
                        report.driver.driverBank.pix_key = this.formRegisterPix.pix_key;
                        report.driver.driverBank.pix_type = this.formRegisterPix.pix_type;
                        report.driver.driverBank.owner_name = this.formRegisterPix.owner_name;
                        report.driver.driverBank.owner_cpf = this.formRegisterPix.owner_cpf;
                    }
                }

                this.formRegisterPix = {
                    pix_type: '',
                    pix_key: '',
                    owner_name: '',
                    owner_cpf: ''
                };
                toast.success(data.message);
                this.toggleModalRegisterPIX()
            }
            else
            {
                toast.warn(data.message);
            }

        }).catch(error => {
            this.setState({loadingRegisterPix: false})
           console.log(error);
           toast.error("Houve um problema ao conectar ao servidor");
        });
    }

    async generateSolicitationPixMotoboy()
    {
        if(!this.empty(this.state.reportViewModal.driver.driverBank.pix_key))
        {
            let servicesIdsSelected = [];
            for(let service of this.state.reportViewModal.services)
            {
                if(service.isSelected === 1)
                {
                    servicesIdsSelected.push(service.id);
                }
            }
            const params = {
                reports: [this.state.reportViewModal],
                dateInit: this.dateInit,
                dateEnd: this.dateEnd,
                datePayment: this.state.datePayment

            };
            this.setState({loadingGenerateSolicitation: true})
            axios.post(this.baseUrl+'/motoboys-payments/generate-solicitation', params)
            .then(response => {
                const data = response.data;
                this.setState({loadingGenerateSolicitation: false})
                if(data.code === 1)
                {
                    toast.success(data.message)
                    const servicesPaid = data.details.servicesPaid;
                    if(servicesPaid.length)
                    {
                        for(const report of this.state.reports)
                        {
                            if(Number(report.driver.driverUser.id) === Number(this.state.reportViewModal.driver.driverUser.id))
                            {
                                if(report.services.length)
                                {
                                    for(const service of report.services)
                                    {
                                        if(servicesPaid.includes(service.id))
                                        {
                                            service.is_motoboy_payment = 1;
                                        }
                                    }
                                }
                            }

                        }
                    }

                    this.toggleModalServicesList().then(() => {
                        this.calculateServicesSelect();
                    })
                }
                else
                {
                    toast.warn(data.message)
                }
            }).catch(error => {
                this.setState({loadingGenerateSolicitation: false})
                toast.error("Houve um problema ao conectar ao servidor");
                console.log(error);
            })
        }
        else
        {
            toast.warn('É necessário cadastrar o PIX do motoboy antes!')
        }
    }

    async generateSolicitationPixAllMotoboy()
    {
        let _continue = true;
        if(this.state.reports.length )
        {
            for(const report of this.state.reports)
            {
                if(report.totalServices > 0)
                {
                    if(this.empty(report.driver.driverBank.pix_key))
                    {
                        _continue = false;
                        break;
                    }
                }
            }
            if(_continue)
            {
                const params = {
                    reports: this.state.reports,
                    dateInit: this.dateInit,
                    dateEnd: this.dateEnd,
                    datePayment: this.state.datePayment
                };
                this.setState({loadingGenerateSolicitation: true})
                axios.post(this.baseUrl+'/motoboys-payments/generate-solicitation', params)
                    .then(response => {
                        const data = response.data;
                        if(response.status === 413)
                        {
                            toast.warn('Houve um excesso de informação enviadas para o servidor');
                        }
                        else
                        {
                            this.setState({loadingGenerateSolicitation: false})
                            if(data.code === 1)
                            {
                                const servicesPaid = data.details.servicesPaid;
                                if(servicesPaid.length)
                                {
                                    for(const report of this.state.reports)
                                    {
                                        if(report.services.length)
                                        {
                                            for(const service of report.services)
                                            {
                                                if(servicesPaid.includes(service.id))
                                                {
                                                    service.is_motoboy_payment = 1;
                                                }
                                            }
                                        }
                                    }
                                }
                                this.calculateServicesSelect().then(()=> {
                                    this.selectAll(false, 'checkbox-reports')
                                })

                                toast.success(data.message)
                            }
                            else
                            {
                                toast.warn(data.message)
                            }
                        }

                    }).catch(error => {
                    this.setState({loadingGenerateSolicitation: false})
                    toast.error("Houve um problema ao conectar ao servidor");
                    console.log(error);
                })
            }
            else
            {
                toast.warn('É necessário cadastrar os PIXs do motoboys antes!')
            }
        }
    }

    async selectMotoboy(el)
    {

        this.motoboySelected = this.state.drivers.filter((v) => {
            if (v.name === el.target.value)
                return v;
        })[0];
    }

    orderArrayObjects(arr, col)
    {
        if(arr.length)
        {
            return arr.sort((a, b) => {
                if(!this.empty(a[col]) && !this.empty(b[col]))
                {
                    return a[col].localeCompare(b[col]);
                }
            })

        }
        return arr;
    }

    getMotoboys(el)
    {
        const query = el.target.value;
        if(query !== '')
        {
            axios.get(this.baseUrl+'/motoboys/query/'+query)
                .then(response => {
                    const data = response.data;
                    console.log(data);
                    if (data.code === 1)
                    {
                        this.setState({drivers: data.details.motoboys ? this.orderArrayObjects(data.details.motoboys, 'first_name') : []})
                    }
                    else
                    {
                        this.setState({drivers: []})
                    }
                })
        }

    }

    async showReports()
    {
        const reportsTemp = this.state.reports;
        if(!this.empty(this.queryReports))
        {
            for(const report of reportsTemp)
            {
                if(report.isSelected === 1 && report.driver)
                {
                    if(report.driver.driverUser)
                    {
                        if(report.driver.driverUser.first_name)
                        {
                            const name = report.driver.driverUser.first_name + ' ' + report.driver.driverUser.last_name ;
                            if(!name.toLowerCase().includes(this.queryReports.toLowerCase()))
                            {
                                report.show = 0;
                                if(report.services.length)
                                {
                                    for(const service of report.services)
                                    {
                                        service.isSelected = 0;
                                    }
                                }
                            }
                            else
                            {
                                report.show = 1;
                                for(const service of report.services)
                                {
                                    service.isSelected = 1;
                                }
                            }
                        }
                    }
                }
            }
            this.setState({reports: reportsTemp})
            await this.calculateServicesSelect()

        }
        else
        {
            for(const report of reportsTemp)
            {
                for(const service of report.services)
                {
                    service.isSelected = 1;
                }
            }
            this.setState({reports: reportsTemp})
            await this.calculateServicesSelect()
        }
    }


    async changeSearchReport(el)
    {
        this.reloadReport = true;
        if(!this.empty(el.target.value))
        {
            this.queryReports = el.target.value;
        }
        else
        {
            this.queryReports = '';
        }
        await this.showReports();
        this.reloadReport = false;
    }

    getTotalReportsWithServices()
    {
        let countReportSelected = 0;
        for(const report of this.state.reports)
        {
            if(report.isSelected > 0)
            {
                countReportSelected++;
            }
        }

        return countReportSelected;
    }





    unselectAllServices()
    {
        const elements = document.querySelectorAll('.checkbox-services');
        for(const element of elements)
        {
            element.checked = false;
        }
        const tempReports = this.state.reports;

        for(const report of tempReports)
        {
            for(const service of report.services)
            {
                service.isSelected = 0;
            }
        }

        this.setState({reports: tempReports})
        this.calculateServicesSelect();
    }

    toggleModalCancelTransaction()
    {
        if(this.state.modalCancelTransaction)
        {
            this.setState({transactionId: ''})
        }
        this.setState({ modalCancelTransaction: !this.state.modalCancelTransaction })
    }

    cancelTransaction()
    {
        if(!this.empty(this.state.transactionId))
        {
            const params = {
                transactionId: this.state.transactionId
            };
            this.setState({loadingCancelTransaction: true})
            axios.post(this.baseUrl+'/motoboys-payments/cancel-transaction', params)
                .then((response) => {
                    const data = response.data;
                    this.setState({loadingCancelTransaction: false})
                    if(data.code === 1)
                    {
                        toast.success('Transação cancelada com sucesso');
                        this.searchReports();
                        this.setState({transactionId: ''})
                        this.toggleModalCancelTransaction();
                    }
                    else
                    {
                        toast.warn(data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({loadingCancelTransaction: true})
            })
        }
        else
        {
            toast.warn('É necessário informar o ID da Operação!')
        }
    }


    changeTransactionId(el)
    {
        this.setState({transactionId: el.target.value})
    }



    changeDatePayment(el)
    {
        this.setState({datePayment: el.target.value})
    }

    selectAll(checked, className)
    {
        const elements = document.querySelectorAll('.'+className);
        for(const element of elements)
        {
            element.checked = checked;
        }

        const tempReports = this.state.reports;
        for(const report of tempReports)
        {
            report.isSelected = checked ? 1 : 0;
        }

        this.setState({reports: tempReports})
        this.calculateServicesSelect();
    }

    selectAndUnselectReport(el, index)
    {
        this.state.reports[index].isSelected = el.target.checked ? 1 : 0;
        this.calculateServicesSelect();
    }

    selectAllServicesMotoboy(checked, className, motoboyId)
    {
        const elements = document.querySelectorAll('.'+className);
        for(const element of elements)
        {
            element.checked = checked;
        }

        const tempReports = this.state.reports;
        for(const report of tempReports)
        {
            if(report.driver.driverInfo.id === motoboyId)
            {
                for(const service of report.services)
                {
                    service.isSelected = checked ? 1: 0;
                }
            }

        }

        this.setState({reports: tempReports})
        this.calculateServicesSelect();
    }

    selectAndUnselectService(el, index)
    {

    }


    getStatusReportText(services)
    {
        let totalServicesPaid = 0;
        if(Array.isArray(services))
        {
            for(let service of services)
            {
                if(service.is_motoboy_payment === 1)
                {
                    totalServicesPaid++;
                }
            }
        }
        if(totalServicesPaid === services.length)
        {
            return 'PAGO';
        }
        else if(totalServicesPaid > 0)
        {
            return 'PARCIAL';
        }
        else
        {
            return 'PENDENTE';
        }
    }

    getStatusReport(services)
    {
        let totalServicesPaid = 0;
        if(Array.isArray(services))
        {
            for(let service of services)
            {
                if(service.is_motoboy_payment === 1)
                {
                    totalServicesPaid++;
                }
            }
        }
        if(totalServicesPaid === services.length)
        {
            return (
                <label className="label bg-success m-l-xs">
                    PAGO
                </label>
            );
        }
        else if(totalServicesPaid > 0)
        {
            return (
                <label className="label bg-warning m-l-xs">
                    PARCIAL
                </label>
            );
        }
        else
        {
            return (
                <label className="label bg-danger m-l-xs">
                    PENDENTE
                </label>
            );
        }
    }

    render() {
        return (
            <div>
                {/*MODAL CANCELAR TRANSAÇÃO*/}
                <Modal
                    isOpen={this.state.modalCancelTransaction}
                    toggle={this.toggleModalCancelTransaction}
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Cancelar Transação</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalCancelTransaction}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">

                        <form className="form-validation">
                            <div className="form-group">
                                <label>ID Operação</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onInput={(e) => this.changeTransactionId(e)}
                                    required
                                />
                            </div>

                        </form>
                    </div>


                    <div className="modal-footer">
                        <button
                            className="btn btn-success"
                            onClick={this.cancelTransaction}
                        >
                            {this.state.loadingCancelTransaction ? (<div className="lds-dual-ring"></div>): ''}
                            Cancelar Transação
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalCancelTransaction}
                        >
                            Fechar
                        </button>
                    </div>

                </Modal>


                {/*MODAL PARA CONFIRMAR A GERAÇÃO DOS PAGAMENTOS*/}
                <Modal
                    isOpen={this.state.modalGeneratePayments}
                    toggle={this.toggleModalGeneratePayments}
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Confirmar Informações para Pagamentos</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalGeneratePayments}
                        >
                            X
                        </button>
                    </div>


                    <div className="modal-body">
                        {/*<div className="col-lg-12 mb-3">
                            <label>Buscar</label>
                            <input
                                type="text"
                                className="form-control"
                                onKeyUp={this.changeSearchReport}
                                placeholder={'Nome/ID'}
                            />
                        </div>*/}
                        <form className="form-validation">
                            <div className="form-group">
                                <label>Data Pagamento</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    onInput={(e) => this.changeDatePayment(e)}
                                />
                                <small>Se a data não for informada, será gerada na data atual</small>
                            </div>

                        </form>
                        {
                            this.state.reports.length ? this.state.reports.map((report, index) =>
                                report.totalServices > 0? (
                                    <div className="flex-card" key={index}>
                                        <div className="flex-item-grow-2">
                                            <div className="font-bold">
                                                {report.driver.driverUser.first_name + ' '}
                                                {report.driver.driverUser.last_name}
                                            </div>
                                            <div>
                                                {report.driver.driverBank.pix_key == null ? (
                                                        <div>
                                                            <div className="text-danger">PIX não cadastrado</div>
                                                            <button className="btn btn-sm btn-info" onClick={() => this.toggleModalRegisterPIX(report.driver)}>Cadastrar PIX</button>
                                                        </div>
                                                    )
                                                    :
                                                    (
                                                        <div>
                                                            <div>
                                                                <span className="font-bold">{report.driver.driverBank.pix_key}</span>
                                                                |
                                                                <span className="text-uppercase">{report.driver.driverBank.pix_type}</span>
                                                            </div>
                                                            <button className="btn btn-sm btn-info" onClick={() => this.toggleModalRegisterPIX(report.driver)}>Atualizar PIX</button>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div>
                                                <button className="btn btn-sm btn-black" onClick={() => this.toggleModalServicesList(report)}>Ver Serviços</button>
                                            </div>
                                        </div>

                                        <div className="flex-item">
                                            Total de serviços: <span className="font-bold"> {report.totalServices}</span>
                                        </div>

                                        <div className="flex-item">
                                            Total a ser pago: <span className="font-bold"> {this.currencyFormat(report.total_w_tax)}</span>
                                        </div>

                                    </div>

                                ): ''
                            ) : ''
                        }

                    </div>


                    <div className="modal-footer">
                       <div className={'flex gap-1'}>
                           <h4>
                               Total de Entregadores:
                               <span className="font-bold">
                                {this.getTotalReportsWithServices()}
                            </span>
                           </h4>
                           <h4>
                               Total Bruto:
                               <span className="font-bold">
                                {this.currencyFormat(this.state.priceTotalServices)}
                            </span>
                           </h4>
                           <h4>
                               Total Pago:
                               <span className="font-bold">
                                {this.currencyFormat(this.state.priceTotalPaid)}
                            </span>
                           </h4>
                           {' '}
                           <h4>
                               Total Liquido:
                               <span className="font-bold">
                                {this.currencyFormat(this.state.priceTotalWithTaxServices)}
                            </span>
                           </h4>

                       </div>
                        <button
                            className="btn btn-success"
                            onClick={this.generateSolicitationPixAllMotoboy}
                        >
                            {this.state.loadingGenerateSolicitation ? (<div className="lds-dual-ring"></div>): ''}
                            Gerar Solicitações de Pagamentos
                        </button>
                        <button
                            className="btn btn-dark"
                            onClick={this.exportToExcelPayments}
                        >
                            Exportar Pagamentos
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalGeneratePayments}
                        >
                            Fechar
                        </button>
                    </div>

                </Modal>

                {/*MODAL LIST SERVICES MOTOBOY*/}
                <Modal
                    isOpen={this.state.modalServicesList}
                    toggle={this.toggleModalServicesList}
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Lista de Serviços</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalServicesList}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">
                        <div>
                            <h4 className="font-bold">
                                {this.state.reportViewModal.driver.driverUser.first_name + ' '} {this.state.reportViewModal.driver.driverUser.last_name}
                            </h4>
                        </div>
                        <div className={'row m-l-xs'}>
                            <button
                                className={'btn btn-sm btn-dark'}
                                onClick={(e) => {this.selectAllServicesMotoboy(true, 'checkbox-services', this.state.reportViewModal.driver.driverInfo.id)}}
                            >
                                Selecionar Tudo
                            </button>
                            <button
                                className={'btn btn-sm btn-dark  m-l-xs'}
                                onClick={(e) => {this.selectAllServicesMotoboy(false, 'checkbox-services', this.state.reportViewModal.driver.driverInfo.id)}}
                            >
                                Desmarcar Tudo
                            </button>
                        </div>
                        <table className='table table-striped' id='table-transaction'>
                            <thead>
                            <tr>
                                <td>#</td>
                                <td>ID</td>
                                <td>Dados Entrega</td>
                                <td>Valor Bruto</td>
                                <td>Valor Liquido</td>
                                <td>Status</td>
                                <td>Pagamento</td>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.reportViewModal.services.length > 0 ? this.state.reportViewModal.services.map((data, i) =>
                                        <tr key={i} className={data.is_motoboy_payment === 1 ? 'opacity' : ''}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className="checkbox checkbox-services"
                                                    onChange={(e) => this.selectAndUnselectService(e, i)}
                                                    defaultChecked={data.isSelected}
                                                />
                                            </td>
                                            <td>
                                                {data.id}
                                            </td>
                                            <td>
                                                <div className="block font-bold">{data.establishment_name}</div>
                                                <div className="block">{data.arrival_address}</div>
                                                <div className="block">{data.service_type} - {data.payment_method}</div>
                                                <div className="block">{this.convertDateTime(data.datetime)}</div>
                                            </td>

                                            <td>
                                                <div className="font-bold">{this.currencyFormat(data.price)}</div>
                                            </td>
                                            <td>
                                                <div className="font-bold">{this.currencyFormat(data.price_w_tax)}</div>
                                            </td>
                                            <td>
                                                {data.status === 1 ? (
                                                    <label className="label bg-warning m-l-xs">
                                                        Pendente
                                                    </label>
                                                ) : null}

                                                {data.status === 4 ? (
                                                    <label className="label bg-success m-l-xs">
                                                        Finalizado
                                                    </label>
                                                ) : null}

                                                {data.status === 6 ? (
                                                    <label className="label bg-danger m-l-xs">
                                                        Recusado
                                                    </label>
                                                ) : null}
                                                {data.status === 5 ? (
                                                    <label className="label bg-danger m-l-xs">
                                                        Cancelado
                                                    </label>
                                                ) : null}
                                            </td>
                                            <td>
                                                {this.empty(data.is_motoboy_payment) ? (
                                                    <label className="label bg-warning m-l-xs">
                                                        Pendente
                                                    </label>
                                                ) : null}

                                                {data.is_motoboy_payment === 1 ? (
                                                    <label className="label bg-success m-l-xs">
                                                        Pago
                                                    </label>
                                                ) : null}
                                            </td>
                                        </tr>
                                    )
                                    :
                                    (<tr>
                                        <td colSpan={8}>Não existe registros</td>
                                    </tr>)
                            }
                            </tbody>
                        </table>

                    </div>


                    <div className="modal-footer">
                        <h5>
                            Total Bruto:
                            <span className="font-bold">
                                {this.currencyFormat(this.state.reportViewModal.total)}
                            </span>
                        </h5>
                        <h4>
                            Total Liquido:
                            <span className="font-bold">
                                {this.currencyFormat(this.state.reportViewModal.total_w_tax)}
                            </span>
                        </h4>
                        <button
                            className="btn btn-success"
                            onClick={this.generateSolicitationPixMotoboy}
                        >
                            {this.state.loadingGenerateSolicitation ? (<div className="lds-dual-ring"></div>): ''}
                            Gerar Solicitação de Pagamento
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalServicesList}
                        >
                            Fechar
                        </button>
                    </div>

                </Modal>

                <Modal
                    isOpen={this.state.modalRegisterPIX}
                    toggle={this.toggleModalRegisterPIX}
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Cadastrar PIX</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalRegisterPIX}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">
                        <div>
                            <h4 className="font-bold">
                                Cadastrar PIX para {this.state.motoboySelected.driverUser.first_name + ' '} {this.state.motoboySelected.driverUser.last_name}
                            </h4>
                        </div>

                        <form className="form-validation">
                            <div className="form-group">
                                <label>Pix Tipo</label>
                                <select
                                    className="form-control"
                                    onChange={(e) => this.changePixType(e)}
                                    defaultValue={this.formRegisterPix.pix_type}
                                >
                                    <option value="">Selecione uma opção</option>
                                    <option value="cpf">CPF/CNPJ</option>
                                    <option value="email">Email</option>
                                    <option value="telefone">Telefone</option>
                                    <option value="aleatoria">Aleatória</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Pix Chave</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onInput={(e) => this.changePixKey(e)}
                                    defaultValue={this.formRegisterPix.pix_key}
                                />
                            </div>

                            <div className="form-group">
                                <label>Nome Responsável</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onInput={(e) => this.changeOwnerName(e)}
                                    defaultValue={this.formRegisterPix.owner_name}
                                />
                            </div>

                            <div className="form-group">
                                <label>CPF Responsável</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    onInput={(e) => this.changeOwnerCPF(e)}
                                    defaultValue={this.formRegisterPix.owner_cpf}
                                />
                            </div>

                        </form>


                    </div>


                    <div className="modal-footer">
                        <button
                            className="btn btn-success"
                            onClick={this.registerPix}
                        >
                            {this.state.loadingRegisterPix ? (<div className="lds-dual-ring"></div>): ''}
                            Atualizar
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalRegisterPIX}
                        >
                            Fechar
                        </button>

                    </div>

                </Modal>

                <BarTitle name="Pagamento Motoboys"/>
                <div className='wrapper-md'>

                    <Painel>
                        <div className="row">
                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <label>Data Inicial</label>
                                <input type="date" className="form-control" onChange={this.changeDateInit}/>
                            </div>

                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <label>Data Final</label>
                                <input type="date" className="form-control" onChange={this.changeDateEnd}/>
                            </div>

                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <label>Motoboys</label>
                                <input type="text" className="form-control" list="merchants_list"
                                       onInput={this.selectMotoboy} onKeyUp={this.getMotoboys}/>

                                <datalist id="merchants_list">
                                    {
                                        this.state.drivers ? this.state.drivers.map((item, index) => {
                                            return (
                                                <option key={index} value={item.name} id={item.id}>{item.name}</option>
                                            )
                                        }) : ''
                                    }
                                </datalist>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-6">
                                <div>Forma de Pagamento</div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="payment_method" className="" id="dinheiro" value='0' onChange={this.changePaymentMethod}/>
                                    <label htmlFor="dinheiro">Dinheiro</label>
                                </div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="payment_method" className="" id="credito" value='1' onChange={this.changePaymentMethod}/>
                                    <label htmlFor="credito">Crédito</label>
                                </div>

                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="payment_method" className="" id="fidelidade" value='2' onChange={this.changePaymentMethod}/>
                                    <label htmlFor="fidelidade">Fidelidade</label>
                                </div>
                            </div>


                            <div className="col-lg-2 col-md-4 col-sm-6">
                                <div>Status</div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="status" className="" id="finalizado" value='4' onChange={this.changeStatus}/>
                                    <label htmlFor="finalizado">Finalizado</label>
                                </div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="status" className="" id="recusado" value='6' onChange={this.changeStatus}/>
                                    <label htmlFor="recusado">Recusado</label>
                                </div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="status" className="" id="pendente" value='1' onChange={this.changeStatus}/>
                                    <label htmlFor="pendente">Pendente</label>
                                </div>
                                <div className='form-group-checkbox'>
                                    <input type="checkbox" name="status" className="" id="cancelado" value='5' onChange={this.changeStatus}/>
                                    <label htmlFor="cancelado">Cancelado</label>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <button className="btn btn-block btn-primary btn-loading" onClick={this.searchReports}>
                                    {this.state.loadingSearch ? (<div className="lds-dual-ring"></div>): ''}
                                    Buscar
                                </button>
                                <button className="btn btn-block btn-danger" onClick={this.toggleModalCancelTransaction}>
                                    Cancelar Transação
                                </button>
                               {/* {this.state.reports.length ?
                                    (<div className="" style={{marginTop: '10px'}}>
                                        <button className="btn btn-block btn-dark btn-loading" onClick={this.exportToExcel}>
                                            {this.state.loadingExport ? (<div className="lds-dual-ring"></div>): ''}
                                            Exportar Serviços
                                        </button>
                                        <button className="btn btn-block btn-success btn-loading" onClick={this.toggleModalGeneratePayments}>
                                            Gerar Informações
                                        </button>
                                    </div>)
                                :''}*/}

                            </div>
                        </div>

                    </Painel>

                    {this.state.reports.length ? (
                        <div>
                            <Painel>
                                <div className="row mb-3">
                                    <div className="col-sm-3">
                                        Total Bruto:
                                        <span className="font-bold">
                                            {this.currencyFormat(this.state.priceTotalServices)}
                                        </span>
                                    </div>
                                    <div className="col-sm-3">
                                        Total Liquido:
                                        <span className="font-bold">
                                            {this.currencyFormat(this.state.priceTotalWithTaxServices)}
                                        </span>
                                    </div>
                                    <div className="col-sm-3">
                                        Total Pago:
                                        <span className="font-bold">
                                            {this.currencyFormat(this.state.priceTotalPaid)}
                                        </span>
                                    </div>
                                    <div className="col-sm-3">
                                        Total de Pedidos:
                                        <span className="font-bold">
                                            {this.state.totalServices}
                                        </span>
                                    </div>
                                    <div className="col-sm-3">
                                        Entregadores a Receber:
                                        <span className="font-bold">
                                            {this.getTotalReportsWithServices()}
                                        </span>
                                    </div>
                                </div>
                                <div className={'row m-l-xs'}>
                                    <button
                                        className={'btn btn-sm btn-dark'}
                                        onClick={(e) => {this.selectAll(true, 'checkbox-reports')}}
                                    >
                                        Selecionar Tudo
                                    </button>
                                    <button
                                        className={'btn btn-sm btn-dark  m-l-xs'}
                                        onClick={(e) => {this.selectAll(false, 'checkbox-reports')}}
                                    >
                                        Desmarcar Tudo
                                    </button>
                                </div>
                                <div className={'row'}>
                                    <div className="form-group col-lg-5 col-sm-12">
                                        <label>Data Pagamento</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            onInput={(e) => this.changeDatePayment(e)}
                                        />
                                        <small>Se a data não for informada, será gerada na data atual</small>
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-lg-6 col-sm-12'}>
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={this.generateSolicitationPixAllMotoboy}
                                        >
                                            {this.state.loadingGenerateSolicitation ? (<div className="lds-dual-ring"></div>): ''}
                                            Gerar Solicitações de Pagamentos
                                        </button>
                                        <button
                                            className="btn btn-sm btn-dark"
                                            onClick={this.exportToExcelPayments}
                                        >
                                            Exportar Pagamentos
                                        </button>
                                    </div>
                                </div>

                            </Painel>
                        </div>
                    ) : ''}


                    <Painel>
                        <div className="row">
                            <div className="col-lg-3 col-sm-12 mb-3">
                            <label>Buscar</label>
                            <input
                                type="text"
                                className="form-control"
                                onKeyUp={this.changeSearchReport}
                                placeholder={'Nome/ID'}
                            />
                        </div>

                            <table className='table table-striped'>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>#</th>
                                    <th>ENTREGADOR</th>
                                    <th>SERVIÇOS</th>
                                    <th>TOTAL PAGO</th>
                                    <th>TOTAL RECEBER</th>
                                    <th>STATUS</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>

                            {
                                this.state.reports.length ? this.state.reports.map((report, index) =>
                                        report.show === 1 ? (
                                            <tr key={index} className={report.quantity_services_paid === report.services.length ? 'opacity' : ''}>
                                                <td>
                                                    {report.quantity_services_paid !== report.services.length ? (
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox checkbox-reports"
                                                            onChange={(e) => this.selectAndUnselectReport(e, index)}
                                                            defaultChecked={report.isSelected}
                                                        />
                                                    ) : ''}

                                                </td>
                                                <td>
                                                    {index + 1}
                                                </td>
                                                <td>
                                                    {report.driver.driverUser.first_name + ' '}
                                                    {report.driver.driverUser.last_name}
                                                    <div>
                                                        {report.driver.driverBank.pix_key == null ? (
                                                                <div>
                                                                    <div className="text-danger">PIX não cadastrado</div>
                                                                    <button className="btn btn-sm btn-info" onClick={() => this.toggleModalRegisterPIX(report.driver)}>Cadastrar PIX</button>
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                <div>
                                                                    <div>
                                                                        <span className="font-bold">{report.driver.driverBank.pix_key}</span>
                                                                        |
                                                                        <span className="text-uppercase">{report.driver.driverBank.pix_type}</span>
                                                                    </div>
                                                                    <button className="btn btn-sm btn-info" onClick={() => this.toggleModalRegisterPIX(report.driver)}>Atualizar PIX</button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    {report.quantity_services_paid + ' '}/{' ' + report.services.length} PAGOS
                                                </td>
                                                <td>
                                                    {this.currencyFormat(report.total_paid)}
                                                </td>
                                                <td>
                                                    {this.currencyFormat(report.total_w_tax)}
                                                </td>
                                                <td>
                                                    {this.getStatusReport(report.services)}
                                                </td>
                                                <td>
                                                    <button className="btn btn-sm btn-black" onClick={() => this.toggleModalServicesList(report)}>Ver Serviços</button>
                                                </td>

                                            </tr>

                                        ) : '' ) : ''
                            }
                                </tbody>
                            </table>
                        </div>

                    </Painel>
                </div>
            </div>
        );
    }

}

export default MotoboysPayment;



// WEBPACK FOOTER //
// ./src/views/MotoboysPayment/index.js